import React from "react";
import { useState, useEffect } from "react";
import { LuCalendarCheck } from "react-icons/lu";
import ReactTooltip from "react-tooltip";
import { Alert, Col, Row, UncontrolledAlert } from "reactstrap";
import axios from "../../../../axios";
import {
  LayoutHeadingShadow,
  LayoutHeadingShadowLeft,
  LayoutRowShadow,
} from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import { toastContainer } from "../../../../utils/toast";
import * as url from "../../../../utils/url";
import DaniContainer from "../../../dani/DaniContainer";
import DaniHeader from "../../../dani/DaniHeader";
import { LayoutData } from "../../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import { Spinner } from "../../../../utils/constants";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actionCreators from "../../../../modules/actions";
import { BiCheckbox, BiCheckboxChecked, BiLinkExternal, BiX } from "react-icons/bi";
import { BsDash } from "react-icons/bs";
import SupportedLanguagesText from "../../../../components/Trivvy/SupportedLanguagesText";

function SchedultTrivvyLoaderBox({
  loaderApiData,
  user,
  setLibraryScheduleLoader,
  libraryScheduleTrivvyLoader,
  setImportTemplateAddedTrivvys,
  ...props
}) {
  const [trivvysGenerated, setTrivvysGenerated] = useState(false);
  const [trivviesData,setTrivviesData] = useState([])
  const [libId,setLibId] = useState(null)
  const [embeddedInTrivvyCreateModal,setEmbeddedInTrivvyCreateModal] = useState(false)

  const toastError=(error)=>{
    if (
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.message
    ) {
      if (
        error.response.data.errors.message == "invalid_translation_plan"
      ) {
        toastContainer(<SupportedLanguagesText invalidTranslationPlan />, "error");
      } else if (
        error.response.data.errors.message ==
        "translation_language_not_available"
      ) {
        toastContainer(<SupportedLanguagesText noTranslationLanguage />, "error");
      } else {
        toastContainer(
          error.response.data.errors.message ||  "Server error occured",
          "error"
        );
      }
    } else {
     
      toastContainer("Error occured while scheduling trivvys",
        "error"
      );
    }
  }

  useEffect(() => {
    if (loaderApiData) {
      setTrivviesData(loaderApiData.trivvyPartsArray)
      setLibId(loaderApiData.libraryId)
      console.log("loaderApiData.embeddedInTrivvyCreateModal",loaderApiData.embeddedInTrivvyCreateModal)
      setEmbeddedInTrivvyCreateModal(loaderApiData.embeddedInTrivvyCreateModal)
      axios
        .post(url.generateLibraryTrivvys, loaderApiData)
        .then(({ data }) => {
          setLibraryScheduleLoader({
            ...libraryScheduleTrivvyLoader,
            loaderApiData: null,
          
          });
          for (const item of data.data) {
            if(item.isPublished){
              axios.put(url.shareTrivia(item._id), {
                sharedWithUsers: item.sharedWithUsers,
                privacy: item.privacy,
                shareTrivvyViaSMS:item.shareTrivvyViaSMS,
                shareTrivvyViaEmail:item.shareTrivvyViaEmail,
              });
            }
            
          }
          if(props.location.pathname.indexOf("library-item")>=0 || props.location.pathname.indexOf("/list")>=0){
            setImportTemplateAddedTrivvys(data.data)
          }
          setTrivvysGenerated(true);
        })
        .catch((err) => {
          setLibraryScheduleLoader({
            display: false,
            loaderApiData: null,
            minimize:false
          });
         
        });
    }
  }, []);

  return (
    <DaniContainer opened={true} minimized={libraryScheduleTrivvyLoader.minimize} solid={true}>
      <DaniHeader 
      trivvysGenerated={trivvysGenerated}
      style={{
        backgroundColor: trivvysGenerated? '#d4edda':''
      }}>
        <div className="text-center font-weight-bold" style={{color:"black",width:"80%", fontSize:'1.1em'}}>
          {trivvysGenerated ? (
            <span style={{color: '#073d13 !important'}}>
              Completed <BiCheckboxChecked />{" "}
            </span>
          ) : (
            "Generating scheduled trivvys"
          )}
        </div>
        <div className="cursor-pointer ml-2" style={{color:"black"}} onClick={()=>{
           setLibraryScheduleLoader({
             ...libraryScheduleTrivvyLoader,
             minimize:!libraryScheduleTrivvyLoader.minimize
           })
        }}>
         {libraryScheduleTrivvyLoader.minimize ? <BiLinkExternal /> :  <BsDash /> }
        </div>
        <div className="cursor-pointer ml-2" style={{color:"black"}} onClick={()=>{
           setLibraryScheduleLoader({
            display: false,
            loaderApiData: null,
            minimize:false
          });
        }}>
         <BiX />
        </div>
      </DaniHeader>

      {
        !libraryScheduleTrivvyLoader.minimized && <div>
           <div>
        {!trivvysGenerated && (
          <UncontrolledAlert color="primary">
           Trivvys are being generated, You can navigate away from the page.
          </UncontrolledAlert>
        )}

        <div className="mt-1">
          {trivviesData &&
          trivviesData.length  ? (
            <div className="px-1">
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "0 20px",
                  minHeight: "200px",
                }}
              >
                {/* <LayoutRowShadow className="row-shadow-header-no-shadow mx-0 fonnt-weight-bold">
                  <LayoutHeadingShadowLeft
                    className={"justify-content-center"}
                    colWidth={6}
                  >
                    Name
                  </LayoutHeadingShadowLeft>

                  <LayoutHeadingShadow
                    className={"justify-content-center"}
                    colWidth={4}
                  >
                    Scheduled
                  </LayoutHeadingShadow>

                  <LayoutHeadingShadow
                    className={"justify-content-center"}
                    colWidth={2}
                  ></LayoutHeadingShadow>
                </LayoutRowShadow> */}

                {trivviesData.map((item, index) => {
                  let itm_color = index % 2 == 0 ? "#ff6233" : "#c6ffe7";
                  return (
                    <LayoutRowShadow>
                      <LayoutData colWidth={6} className="cursor-pointer">
                        <div data-tip={item.name} className="d-flex">
                          <span
                            className="trivia-list-item-color-chip"
                            style={{ backgroundColor: itm_color }}
                          />

                          <span
                            style={{ display: "block" }}
                            className="survey-item-title d-block"
                          >
                            {item.name}

                            <div className="item-source-trivvy-list">
                              Source:Library
                            </div>
                          </span>
                        </div>
                        <ReactTooltip />
                      </LayoutData>

                      <LayoutData className="text-center" colWidth={4}>
                        {" "}
                        <div className="survey-createddate-text">
                          {item.scheduledDate ? (
                            <span>
                              <div>
                                {moment(item.scheduledDate).format(
                                  "MMM DD, YYYY"
                                )}
                              </div>
                            </span>
                          ) : (
                            <div className="text-center">
                              <LuCalendarCheck size={23} color="gray" />
                            </div>
                          )}
                        </div>
                      </LayoutData>

                      <LayoutData className="text-center" colWidth={2}>
                        {!trivvysGenerated && (
                          <img src={Spinner} height="25px" width="25px" />
                        )}
                      </LayoutData>
                    </LayoutRowShadow>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {trivvysGenerated && (
        <div className="loaderBox_footer">
          <b className="text-center">
            Trivvys completed{" "}
            <span
              className="text-info cursor-pointer"
              onClick={() => {
                setTimeout(() => {
                  setLibraryScheduleLoader({
                    display: false,
                    loaderApiData: null,
                    minimize:false
                  });
                }, 1000);


      console.log("PLAIN.embeddedInTrivvyCreateModal",embeddedInTrivvyCreateModal)

                if(embeddedInTrivvyCreateModal){
                  
                  props.history.push(
                    `/home/trivia/${user.profile.organizationId._id}/list`
                  );

                  return
                }

                if(props.location.pathname.indexOf("library-item")>=0){
                  //  if(props.location.pathname.indexOf("/view/questions")>=0) {
                  //   props.history.push(
                  //     `/home/trivia/${user.profile.organizationId._id}/library-item/${libId}/view/trivvys`
                  //   );
                  //  }else{
                  //   props.history.push(
                  //     `/home/trivia/${user.profile.organizationId._id}/library-item/${libId}/view/questions`
                  //   );
                  //  }
                }else{
                  props.history.push(
                    `/home/trivia/${user.profile.organizationId._id}/library-item/${libId}/view/questions`
                  );
                }

               
              }}
            >
              click here
            </span>{" "}
            to view{" "}
          </b>
        </div>
      )}
        </div>
      }

     

     
    </DaniContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    libraryScheduleTrivvyLoader:state.trivia.libraryScheduleTrivvyLoader ||{display:false},
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLibraryScheduleLoader: (data) =>
      dispatch(actionCreators.setLibraryScheduleLoader(data)),
      setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SchedultTrivvyLoaderBox, axios));
